import { createAppSlice } from '../app.slice';

const initialState = {
  phoneNumbs: [],
  emails: [],
};

const setMainContact = (currentContactId, newContactId) => {
  if (currentContactId === Number(newContactId)) return 'S';

  return 'N';
};

export const userContactsSlice = createAppSlice({
  name: 'userContactsSlice',
  initialState,
  reducers: {
    userContactsRequest: (state) => state,
    userContactsSucess: (state, action) => {
      const { userContacts, contactType } = action.payload;

      if (contactType === 'TMOVEL') {
        state.phoneNumbs = userContacts;
      } else {
        state.emails = userContacts;
      }
    },
    userContactsFailure: (state) => state,
    setFavoriteContactRequest: (state) => state,
    setFavoriteContactSuccess: (state, action) => {
      const { contactId, contactType } = action.payload;

      if (contactType === 'TMOVEL') {
        state.phoneNumbs.forEach((data) => {
          const mainContactValue = setMainContact(data.contactId, contactId);

          data.mainContact = mainContactValue;
        });
      } else {
        state.emails.forEach((data) => {
          const mainContactValue = setMainContact(data.contactId, contactId);

          data.mainContact = mainContactValue;
        });
      }
    },
    setFavoriteContactFailure: (state) => state,
  },
});
